import React, { useState, useRef, useEffect } from 'react';

interface IProps
    extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    form?: any;
    allowclear: boolean;
    onClear?: any;
}
function Input(props: IProps): JSX.Element {
    const {
        onChange = () => { },
        onClear = () => { },
        onBlur = () => { },
        allowclear = false,
        disabled = false,
        form = null,
        name = '',
        value = '',
        readOnly = false
    } = props;
    const inputRef = useRef(null);
    const [clearVisible, setClearVisible] = useState(false);
    const [focused, setFocused] = useState(false);
    const handleChange = (e) => {
        onChange(e);
    };
    const handleFocus = () => {
        setFocused(true);
    };
    const handleBlur = (e) => {
        setFocused(false);
        onBlur(e);
    };
    const handleClear = (e) => {
        form.setFieldsValue({ [name]: '' });
        form.validateFields([name]);
        inputRef.current.focus();
        onClear(e);
        return false;
    };
    const ClearIcon = (
        <span className="input-clear-icon-hidden input-clear-icon" onClick={handleClear}>
            <svg
                viewBox="64 64 896 896"
                focusable="false"
                data-icon="close-circle"
                width="1em"
                height="1em"
                fill="#999999"
                aria-hidden="true"
            >
                <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" />
            </svg>
        </span>
    );
    const input = (
        <input
            {..._.omit(props, ['allowclear', 'form'])}
            className="input"
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            autoComplete="off"
            type="text"
            ref={inputRef}
        />
    );
    const className = classnames({
        'input-wrapper': true,
        'input-wrapper-disabled': disabled,
        'input-suffix-wrapper': true,
        'input-suffix-wrapper-focused': focused && !readOnly,
        'input-suffix-wrapper-clear': clearVisible
    });
    useEffect(() => {
        setClearVisible(!!value);
    }, [value]);
    useEffect(() => {
        if (disabled || readOnly) {
            setClearVisible(false);
        }
    }, [disabled, readOnly]);
    return (
        <div className={className}>
            {input}
            {allowclear && <div className="input-suffix">{clearVisible && ClearIcon}</div>}
        </div>
    );
}

export default Input;
